'use strict';

import $ from 'jquery';
require('jquery-confirm');
require('jquery-confirm/css/jquery-confirm.css');

/**
 * 共通ライブラリ
 */
class Library {
    /**
     * Cookieをセットする
     *
     * @param {*} myCookie Cookieキー
     * @param {*} myValue Cookieにセットする値
     * @param {*} myDay Cookie有効期限(日)
     */
    mySetCookie(myCookie, myValue, myDay) {
        let myExp = new Date(),
            myItem,
            myExpires;

        myExp.setTime(myExp.getTime() + (myDay * 24 * 60 * 60 * 1000));
        myItem = myCookie + '=' + escape(myValue) + ';path=/;';
        myExpires = 'expires=' + myExp.toGMTString();
        document.cookie =  myItem + myExpires;
    }

    /**
     * Cookieを取得する
     *
     * @param {*} myCookie Cookieキー
     * @returns
     */
    myGetCookie(myCookie) {
        myCookie += '=';

        let myValue = null,
            myStr = document.cookie + ';' ,
            myOfst = myStr.indexOf(myCookie),
            myStart,
            myEnd;

        if (myOfst !== -1) {
            myStart = myOfst + myCookie.length;
            myEnd   = myStr.indexOf(';', myStart);
            myValue = unescape(myStr.substring(myStart, myEnd));
        }

        return myValue;
    }

    /**
     * URIエンコードをしてcookie取得する
     *
     * @param {string} name 取得するcookie名
     * @returns {string|boolean}
     */
    getEncodeCookie(name) {
        if (name === undefined || name === null) {
            return false;
        }

        let decodeVal;

        try {
            decodeVal = decodeURIComponent(this.myGetCookie(name));
        } catch(e) {
            console.log(e);
            return null;
        }

        if (decodeVal === 'null') {
            decodeVal = null;
        }

        return decodeVal;
    }

    /**
     * URIデコードをしてcookie取得する
     *
     * @param {string} name 保存するcookie名
     * @param {string} val 保存データ
     * @param {integer} day 保存日数
     */
    setEncodeCookie(name, val, day) {
        if (name === undefined || name === null || val === undefined) {
            return false;
        }

        if (day === undefined || day === null) {
            day = 365;
        }

        this.mySetCookie(name, encodeURIComponent(val), day);
    }

    /**
     * 指定のGETパラメータを取得
     *
     * @param {type} name
     * @returns {getQueryString.arg|Object}
     */
    getQueryString(name) {
        let arg = new Object,
            url = location.search.substring(1).split('&'),
            key,
            urlLength = url.length;

        for (let i = 0; urlLength > i; i++) {
            if (! url[i]) {
                continue;
            }
            key = url[i].split('=');
            arg[key[0]] = key[1];
        }

        if (arg[name]) {
            return arg[name];
        }

        return false;
    }

    /**
     * reportFlg（有効銘柄フラグ）を判定する
     *
     * @returns bool true: 有効銘柄ページ false: 無効銘柄ページ
     */
    isReport() {
        if ($('#reportFlg').val() === '1') {
            return true;
        }

        return false;
    }

    /**
     * jquery-confirm $.alertを実行する
     *
     * @param {String} title アラートタイトル
     * @param {String} content アラートテキスト
     */
    jqAlert(title, content) {
        if (title === undefined) {
            title = '';
        }

        if (content === undefined) {
            content = '';
        }

        // PC,SPで横幅変動
        let boxWidth;
        if ($('#uaStr').val() === 'pc') {
            boxWidth = '500px'
        } else {
            boxWidth = '80%';
        }

        //アラート表示
        $.alert({
            title: title,
            content: content,
            closeIcon: true,
            type: 'orange',
            boxWidth: boxWidth,
            useBootstrap: false,
            backgroundDismiss: true,
            animateFromElement: false,
            typeAnimated: false,
            animation: 'opacity',
            closeAnimation: 'opacity'
        });
    }

    /**
     * 整数又は小数かチェックする
     * @param {type} numVal
     * @returns {Boolean}
     */
    isNumber(numVal) {
        // チェック条件パターン
        let pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;

        // 数値チェック
        return pattern.test(numVal);
    }

    /**
     * 数値によって正負記号付き文字列を返却
     *
     * @param {integer|float} num
     * @param integer decimals 小数点以下の桁数
     * @param string|null nullString null時の返却文字列
     * @return string $resultAdd 数値が正の場合「+」付き数値、数値が負の場合「-」付き数値、
     *                           nullであればnullを返却
     */
    addSign(num, decimals, nullString) {
        decimals = decimals || 0;
        nullString = nullString || '';
        let $resultAdd = nullString;

        if (isNumber(num)) {
            $resultAdd = Highcharts.numberFormat(num, decimals, '.', ',');

            // 正の時
            if (num > 0) {
                $resultAdd = '+' + $resultAdd;
            }
        }

        return $resultAdd;
    }

    /**
     * 数値によってHTML class文字列を返却
     *
     * @param float|null num 数値
     * @param boolean $stockFlg true: 株価関係数値として判定
     * @return string $class class文字列 負：「minus」 正：「plus」
     */
    classSign(num, stockFlg) {
        let className = '';

        if (! stockFlg) {
            stockFlg = false;
        }

        if (num > 0) { // 正の時
            className = stockFlg ? 'stock_plus' : 'plus';
        } else if (num < 0) { // 負の時
            className = stockFlg ? 'stock_minus' : 'minus';
        }

        return className;
    }

    /**
     * 数値が0かnullの場合、「-」を返却する
     * 数値が0でない場合、数値をそのまま返却する
     *
     * @param {integer|float} num
     */
    emptyCheck(num, emptyStr) {
        emptyStr = emptyStr || '－';

        if (num == 0 || num == null) {
            return emptyStr;
        }

        return num;
    }

    /**
     * 文字列を指定バイト数切り取り
     */
    substr(text, len, truncation) {
        if (truncation === undefined) {
            truncation = '';
        }

        let text_array = text.split('');
        let count = 0;
        let str = '';
        for (let i = 0; i < text_array.length; i++) {
            let n = escape(text_array[i]);

            if (n.length < 4) {
                count++;
            } else {
                count += 2;
            }

            if (count > len) {
                return str + truncation;
            }

            str += text.charAt(i);
        }
        return text;
    }

    /**
     * 英数字およびスペースの全角→半角変換
     */
    toHankaku(str) {
        return str
            // 全角数字 → 半角数字
            .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
            // 全角英字 → 半角英字
            .replace(/[Ａ-Ｚａ-ｚ]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
            // 全角スペース → 半角スペース
            .replace(/　/g, ' ')
            // 全角記号 → 半角記号
            .replace(/[！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［￥］＾＿｀｛｜｝～]/g, s =>
                String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
            );
    }

    /**
     * 日付のフォーマット化
     */
    dateFormat(date, format) {
        date = new Date(date);
        format = format.replace(/yyyy/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));

        return format;
    };

    /**
     * 株価を修正係数で補正する
     * STOCK_PRICE / ADJUSTMENT_COEF * 最新のADJUSTMENT_COEF
     *
     * @param double $volume 株価
     * @param double $adjustmentCoef 修正係数
     * @param double $adjustmentCoef 最新日付の修正係数
     * @return double
     */
    calcAdjustment(stockPrice, adjustmentCoef, latestAdjustmentCoef) {
        let retStockPrice = null;
        if (adjustmentCoef != 0) {
            retStockPrice = this.castFloat(stockPrice / adjustmentCoef * latestAdjustmentCoef, 1);
        }

        return retStockPrice;
    }

    /**
     * 決算期区分の表示形式を変更
     * @param {String} fy 決算期
     * @returns {String}
     */
    convFiscalTermType(type) {
        switch (type) {
            case 'Q1':
                type = '1Q';
                break;
            case 'H1':
            case 'Q2':
                type = '2Q';
                break;
            case 'Q3':
                type = '3Q';
                break;
            case 'Q4':
                type = '4Q';
                break;
            case 'Q5':
                type = '5Q';
                break;
            case 'FY':
                type = '本';
                break;
            default:
                type = '－';
        }
        return type;
    }

    /**
     * 出来高を修正係数で補正する
     * STOCK_PRICE / ADJUSTMENT_COEF * 最新のADJUSTMENT_COEF
     *
     * @param double $volume 出来高
     * @param double $adjustmentCoef 修正係数
     * @param double $adjustmentCoef 最新日付の修正係数
     * @return double
     */
    calcVolumeAdjustment(volume, adjustmentCoef, latestAdjustmentCoef) {
        let retStockPrice = null;
        if (latestAdjustmentCoef != 0) {
            retStockPrice = this.castFloat(volume * adjustmentCoef / latestAdjustmentCoef, 0);
        }

        return retStockPrice;
    }

    castFloat(value, round) {
        return value.toFixed(round);
    }

    // UAによるブラウザ判定
    isFireFox() {
        const agent = window.navigator.userAgent.toLowerCase();
        if (agent.indexOf('firefox') != -1) {
            return true;
        }

        return false;
    }

    isSafari() {
        const agent = window.navigator.userAgent.toLowerCase()
        // chrome/edgeのUAに'safari'が含まれるためsafariのみで判定
        if (agent.indexOf('safari') != -1 && agent.indexOf('chrome') == -1 && agent.indexOf('edge') == -1) {
            return true;
        }

        return false;
    }

    isIpad() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (
            agent.indexOf('ipad') != -1 ||
            (agent.indexOf('macintosh') != -1 && 'ontouchend' in document)
        ) {
            return true;
        }

        return false;
    }

    isIphone() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (agent.indexOf('iphone') != -1) {
            return true;
        }

        return false;
    }

    isAndroid() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (agent.indexOf('android') != -1) {
            return true;
        }

        return false;
    }
}

export const lib = new Library();
